module.exports = __webpack_public_path__ + "static/media/fb.26589391.svg";